import {
  IonButton,
  IonButtons,
  IonCard,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonList,
  IonLoading,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonText,
  IonTextarea,
  IonTitle,
  IonToggle,
  IonToolbar,
  useIonToast,
} from "@ionic/react";
import { trashBinOutline, filter } from "ionicons/icons";
import { nanoid } from "nanoid";
import React, { useEffect, useState } from "react";
import { useList, useObject } from "react-firebase-hooks/database";
import { useDocument } from "react-firebase-hooks/firestore";
import hitungSablon from "../../utils/harga-sablon";
import mergeArray from "../../utils/merge-array";
import { sortVarian } from "../../utils/sort";
import { useFirebase } from "../firebase-provider";
import PageLayout from "../layout";
import Loading from "../loading";

const EditTransaction = ({ match, history }) => {
  const id = match.params.id;
  const [toast] = useIonToast();
  const { database, firestore } = useFirebase();
  const [isLoading, setLoading] = useState({ isActive: false, message: "" });
  // DATA AWAL
  const initFilterProduct = {
    kategori: "",
    merk: "",
    nama: "",
  };

  const initFilterVarian = {
    kategori: "",
    merk: "",
    nama: "",
  };

  const initTempData = { jumlah: 0, potongan: 0 };

  var initSablon = {
    panjang: 0,
    lebar: 0,
    potongan: 0,
    posisi: "Depan",
    id: nanoid(4),
  };

  const initDataPesanan = {
    id: id,
    pesanan: [{ id: nanoid(4), produk: {}, jasa: {}, isJasa: false }],
    detail: {
      nama: "",
      kontak: "",
      alamat: "",
    },
    pembayaran: {
      total: 0,
      dibayar: 0,
      akun: "",
      dikonfirmasi: false,
    },
    pengiriman: {
      jenis: "COD",
      biaya: 0,
    },
    status: "Dibuat",
    riwayat: [{ waktu: new Date(), status: "dibuat" }],
  };

  const [filterProduct, setFilterProduct] = useState(initFilterProduct);
  const [filterVarian, setFilterVarian] = useState(initFilterVarian);
  const [tempData, setTempData] = useState(initTempData);
  const [sablon, setSablon] = useState(initSablon);

  const [modal, setModal] = useState({
    product: false,
    service: false,
    index: 0,
    isEdit: false,
  });
  const [dataPesanan, setDataPesanan] = useState(initDataPesanan);

  // API
  const [listProduct, setListProduct] = useState([]);

  const [snapshotsStok, loadingStok] = useObject(database.ref(`stock`));
  const [snapshotsPesanan, loadingPesanan] = useDocument(
    firestore.doc("transaksi/" + id)
  );
  const [snapshots, loading] = useList(database.ref("product"));

  useEffect(() => {
    if (snapshotsPesanan) {
      setDataPesanan(snapshotsPesanan.data());
    }
  }, [snapshotsPesanan]);

  useEffect(() => {
    if (snapshots) {
      setListProduct(snapshots.map((e) => e.val()));
    }
  }, [snapshots]);

  // Manajemen Stok
  const newStok = (myArr) => {
    var _pesanan = (myArr || [])
      .map((psn) =>
        Object.keys(psn.produk).map((prd) => ({
          sku: psn.produk[prd].sku,
          jumlah: psn.produk[prd].jumlah,
        }))
      )
      .flat();

    var _pesanan_final = _pesanan.reduce((final, data) => {
      let isAlready = final.find((val) => val.sku === data.sku);
      if (!isAlready) {
        final.push(data);
      } else {
        var index = final.indexOf(isAlready);
        final[index].jumlah =
          Number(final[index].jumlah || 0) + Number(data.jumlah || 0);
      }
      return final;
    }, []);

    return Object.fromEntries(
      new Map(_pesanan_final.map((el) => [el.sku, el.jumlah]))
    );
  };

  const updatedStok = () => {
    var _dataRealSku = newStok(snapshotsPesanan?.data()?.pesanan);
    var _dataSku = newStok(dataPesanan?.pesanan);

    var _newSku = Object.fromEntries(
      new Map(
        Object.keys(_dataSku).map((x) => [
          x,
          Number(snapshotsStok?.val()[x] || 0) +
            Number(_dataRealSku[x] || 0) -
            Number(_dataSku[x] || 0),
        ])
      )
    );
    return { ...snapshotsStok?.val(), ..._newSku };
  };

  const updatedStokDel = () => {
    var _dataRealSku = newStok(snapshotsPesanan?.data()?.pesanan);
    var _dataSku = newStok(dataPesanan?.pesanan);

    var _newSku = Object.fromEntries(
      new Map(
        Object.keys(_dataSku).map((x) => [
          x,
          Number(snapshotsStok?.val()[x] || 0) + Number(_dataRealSku[x] || 0),
        ])
      )
    );
    return { ...snapshotsStok?.val(), ..._newSku };
  };

  // Total
  const total_dibayar = dataPesanan?.pesanan
    ?.map((psn) => {
      const _total = Object.keys(psn.produk)
        .map((el) => {
          const _sablon = Object.keys(psn.jasa)
            .map((s) => hitungSablon(psn.jasa[s].panjang, psn.jasa[s].lebar))
            .reduce((a, b) => a + b, 0);
          const _data = psn.produk[el];
          const _harga = Number(_data.harga) + Number(_sablon);
          return (Number(_harga || 0) - _data.potongan) * _data.jumlah;
        })
        .reduce((c, d) => c + d, 0);
      return _total;
    })
    .reduce((c, d) => c + d, 0);

   
    const [isFilter, setFilter] = useState(false);

  
    useEffect(() => {
      if (snapshots) {
        setListProduct(snapshots.map((e) => e.val()));
      }
    }, [snapshots]);
  
    const filteredProduct =
      listProduct.filter(
        (e) =>
          (filterProduct.kategori
            ? e.category === filterProduct.kategori
            : true) &&
          (filterProduct.merk ? e.brand === filterProduct.merk : true)
      ) || [];
  
    const selectedProduct =
      filteredProduct.filter((e) => e.product_name === filterProduct.nama)[0]
        ?.varian || [];
  
    const selectedVarian = selectedProduct.filter(
      (s) =>
        (s.data?.ukuran ? s.data.ukuran === filterVarian.ukuran : true) &&
        (s.data?.warna ? s.data.warna === filterVarian.warna : true)
    )[0];
  
    const allVariant = mergeArray(
      selectedProduct.map((e) => Object.keys(e.data || {})).flat()
    ).sort((a, b) => sortVarian(a, b));

  // SUBMIT HANDLER
  const [process, setProcess] = useState({
    text: "Update Transaksi",
    disabled: false,
  });

  const buat_transaksi = async () => {
    setProcess({ text: "Memproses. . .", disabled: true });
    setLoading({ isActive: true, message: "Memperbarui Transaksi. . ." });

    // Prepare
    let newStok = { ...updatedStok() };
    let currStok = snapshotsStok?.val();
    Object.keys(updatedStok()).forEach(
      (key) => updatedStok()[key] === currStok[key] && delete newStok[key]
    );

    const _setTransaksi = firestore
      .collection("transaksi")
      .doc(dataPesanan?.id)
      .set({
        ...dataPesanan,
        pembayaran: { ...dataPesanan.pembayaran, total: total_dibayar },
      });

    const _setStok = database.ref("stock").update(newStok);

    await Promise.all([_setTransaksi, _setStok])
      .then(() => {
        toast({
          message: "Transaksi berhasil diperbarui!",
          duration: 3000,
          color: "success",
          position: "top",
        });
        history.push(`/app/transaction/view/${id}`);
      })
      .catch(() => {
        toast({
          message: "Terjadi Kesalahan!",
          duration: 1000,
          color: "danger",
          position: "top",
        });
      });
    setDataPesanan(initDataPesanan);
    setProcess({ text: "Update Transaksi", disabled: false });
    setLoading({ isActive: false, message: "" });
  };

  const hapus_transaksi = async () => {
    // Prepare
    setLoading({ isActive: true, message: "Menghapus Transaksi. . ." });

    let newStok = { ...updatedStokDel() };
    let currStok = snapshotsStok?.val();
    Object.keys(updatedStok()).forEach(
      (key) => updatedStokDel()[key] === currStok[key] && delete newStok[key]
    );
    await database
      .ref("stock")
      .update(newStok)
      .then(() => {
        firestore
          .collection("transaksi")
          .doc(dataPesanan?.id)
          .delete()
          .then(() => {
            toast({
              message: "Transaksi berhasil dihapus!",
              duration: 3000,
              color: "success",
              position: "top",
            });
            history.push(`/app/transaction`);
          })
          .catch(() => {
            toast({
              message: "Terjadi Kesalahan!",
              duration: 1000,
              color: "danger",
              position: "top",
            });
          });
      });
    setLoading({ isActive: false, message: "" });
  };

  // Input Handler
  const detailHandlerChange = (e) =>
    setDataPesanan({
      ...dataPesanan,
      detail: { ...dataPesanan?.detail, [e.target.name]: e.detail.value },
    });

  const pengirimanHandlerChange = (e) =>
    setDataPesanan({
      ...dataPesanan,
      pengiriman: {
        ...dataPesanan?.pengiriman,
        [e.target.name]: e.detail.value,
      },
    });

  const pesanan = () => {
    return (
      <>
        {dataPesanan?.pesanan?.map((e, i) => {
          return (
            <React.Fragment key={e.id}>
              <IonCard className="ion-margin-bottom">
                <IonToolbar color="primary">
                  <IonTitle>Pesanan {i + 1}</IonTitle>
                  <IonButtons slot="end">
                    <IonButton
                      onClick={() => {
                        let newDataPesanan = [...dataPesanan?.pesanan].filter(
                          (x, y) => y !== i
                        );
                        if (dataPesanan?.pesanan.length > 1) {
                          setDataPesanan({
                            ...dataPesanan,
                            pesanan: newDataPesanan,
                          });
                        } else {
                          setDataPesanan({
                            ...dataPesanan,
                            pesanan: [
                              {
                                id: nanoid(4),
                                produk: {},
                                jasa: {},
                                isJasa: false,
                              },
                            ],
                          });
                        }
                      }}
                    >
                      <IonIcon icon={trashBinOutline}></IonIcon>
                    </IonButton>
                  </IonButtons>
                </IonToolbar>
                <IonItemGroup>
                  {/* Produk */}
                  <IonItemDivider>
                    <IonLabel>Produk</IonLabel>
                  </IonItemDivider>
                  {Object.keys(e.produk).length === 0 && (
                    <IonItem lines="full">
                      <IonLabel color="medium">
                        <p>Belum ada produk ditambahkan pada pesanan ini</p>
                      </IonLabel>
                    </IonItem>
                  )}
                  {Object.keys(e.produk).map((p) => {
                    const data = e.produk[p];

                    const biaya_sablon = Object.keys(e.jasa)
                      .map((s) =>
                        hitungSablon(e.jasa[s].panjang, e.jasa[s].lebar)
                      )
                      .reduce((a, b) => a + b, 0);

                    const harga_akhir =
                      Number(data.harga) + Number(biaya_sablon);
                    return (
                      <React.Fragment key={p}>
                        <IonItem
                          lines="full"
                          detail
                          button
                          onClick={() => {
                            setModal({
                              ...modal,
                              product: true,
                              index: i,
                              isEdit: true,
                            });

                            setFilterProduct({
                              kategori: data.kategori,
                              merk: data.merk,
                              nama: data.nama,
                            });

                            setFilterVarian(data.data);

                            setTempData({
                              jumlah: data.jumlah,
                              potongan: data.potongan,
                            });
                          }}
                        >
                          <IonLabel slot="start">
                            {data.nama} ({data.data.warna}, {data.data.ukuran})
                            <IonText color="medium">
                              <p>
                                <small>{data.merk}</small>
                              </p>
                            </IonText>
                            <IonText
                              color={
                                Number(data.potongan || 0) === 0
                                  ? `success`
                                  : `warning`
                              }
                            >
                              <p>
                                @
                                {new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  maximumSignificantDigits: 10,
                                }).format(
                                  Number(harga_akhir || 0) -
                                    Number(data.potongan || 0)
                                )}
                              </p>
                            </IonText>
                            <IonText color="danger">
                              <p>
                                -
                                {new Intl.NumberFormat("id-ID", {
                                  style: "currency",
                                  currency: "IDR",
                                  maximumSignificantDigits: 10,
                                }).format(Number(data.potongan || 0))}
                              </p>
                            </IonText>
                          </IonLabel>
                          <IonLabel>
                            <p>x {data.jumlah}</p>
                          </IonLabel>
                          <IonLabel color="success" className="ion-text-right">
                            <p>
                              {new Intl.NumberFormat("id-ID", {
                                style: "currency",
                                currency: "IDR",
                                maximumSignificantDigits: 10,
                              }).format(
                                (Number(harga_akhir || 0) - data.potongan) *
                                  data.jumlah
                              )}
                            </p>
                          </IonLabel>
                        </IonItem>
                      </React.Fragment>
                    );
                  })}

                  <IonButton
                    fill="clear"
                    size="small"
                    color="dark"
                    onClick={() => {
                      setFilterVarian(initFilterVarian);
                      setTempData(initTempData);
                      setModal({ ...modal, product: true, index: i });
                    }}
                  >
                    Tambah Produk
                  </IonButton>

                  {/* Jasa */}
                  <IonItemDivider>
                    <IonLabel color="dark">
                      Tambahkan sablon pada produk ini
                    </IonLabel>
                    <IonToggle
                      slot="end"
                      checked={e.isJasa}
                      onIonChange={(toggle) => {
                        let newData = {
                          ...e,
                          jasa: {},
                          isJasa: toggle.detail.checked,
                        };
                        let newDataPesanan = [...dataPesanan?.pesanan];
                        newDataPesanan[i] = newData;
                        setDataPesanan({
                          ...dataPesanan,
                          pesanan: newDataPesanan,
                        });
                      }}
                    ></IonToggle>
                  </IonItemDivider>
                  {e.isJasa && (
                    <>
                      {Object.keys(e.jasa).length === 0 && (
                        <IonItem lines="full">
                          <IonLabel color="medium">
                            <p>Belum ada sablon ditambahkan pada pesanan ini</p>
                          </IonLabel>
                        </IonItem>
                      )}
                      {Object.keys(e.jasa).map((j) => {
                        const data = e.jasa[j];
                        return (
                          <React.Fragment key={j}>
                            <IonItem
                              lines="full"
                              detail
                              button
                              onClick={() => {
                                setModal({
                                  ...modal,
                                  service: true,
                                  index: i,
                                  isEdit: true,
                                });
                                setSablon({
                                  panjang: data.panjang,
                                  lebar: data.lebar,
                                  potongan: data.potongan,
                                  posisi: data.posisi,
                                  id: data.id,
                                });
                              }}
                            >
                              <IonLabel slot="start">{data.posisi}</IonLabel>
                              <IonLabel>
                                <p>
                                  {data.panjang} cm x {data.lebar} cm
                                </p>
                              </IonLabel>
                              <IonLabel
                                color="success"
                                className="ion-text-right"
                              >
                                <p>
                                  {new Intl.NumberFormat("id-ID", {
                                    style: "currency",
                                    currency: "IDR",
                                    maximumSignificantDigits: 10,
                                  }).format(
                                    hitungSablon(data.panjang, data.lebar)
                                  )}
                                </p>
                              </IonLabel>
                            </IonItem>
                          </React.Fragment>
                        );
                      })}

                      <IonButton
                        fill="clear"
                        color="dark"
                        size="small"
                        onClick={() => {
                          setSablon(initSablon);
                          setModal({ ...modal, service: true, index: i });
                        }}
                      >
                        Tambah Sablon
                      </IonButton>
                    </>
                  )}
                </IonItemGroup>
              </IonCard>
            </React.Fragment>
          );
        })}

        {/* Tambah Pesanan */}
        <IonButton
          fill="clear"
          color="dark"
          onClick={() =>
            setDataPesanan({
              ...dataPesanan,
              pesanan: [
                ...dataPesanan?.pesanan,
                { id: nanoid(4), produk: {}, jasa: {}, isJasa: false },
              ],
            })
          }
        >
          Tambah Pesanan
        </IonButton>
      </>
    );
  };

  // ADD PRODUCT

  return (
    <PageLayout title={"Edit Transaksi " + id}>
      {(loading || loadingPesanan || loadingStok) && <Loading />}
      <IonLoading isOpen={isLoading.isActive} message={isLoading.message} />
      {snapshotsPesanan && (!loading || !loadingPesanan) && (
        <>
          <IonList>{pesanan()}</IonList>
          <IonList>
          <IonCard>
                <IonItem lines="none">
                  <IonLabel position="stacked">Jumlah Pesanan</IonLabel>
                  <IonText className="ion-padding-bottom ion-padding-top">
                    <strong>
                      {dataPesanan?.pesanan
                        ?.map((psn) => {
                          const _total = Object.keys(psn.produk)
                            .map((el) => psn.produk[el].jumlah)
                            .reduce((c, d) => c + d, 0);
                          return _total;
                        })
                        .reduce((c, d) => c + d, 0)}
                    </strong>{" "}
                    <i>pcs</i>
                  </IonText>

                  <IonLabel position="stacked">Total Harus Dibayar</IonLabel>
                  <IonText className="ion-padding-bottom ion-padding-top">
                    <strong>
                      {new Intl.NumberFormat("id-ID", {
                        style: "currency",
                        currency: "IDR",
                        maximumSignificantDigits: 10,
                      }).format(total_dibayar)}
                    </strong>
                  </IonText>
                </IonItem>
              </IonCard>

            <IonItemGroup>
              <IonItemDivider>
                <IonLabel color="dark">Informasi Pemesan</IonLabel>
              </IonItemDivider>
              <IonItem>
                <IonLabel position="stacked">Nama Pemesan</IonLabel>
                <IonInput
                  name="nama"
                  value={dataPesanan?.detail?.nama}
                  onIonChange={detailHandlerChange}
                  placeholder="Budi Setiawan"
                  required
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Kontak (Telp./WA)</IonLabel>
                <IonInput
                  name="kontak"
                  value={dataPesanan?.detail?.kontak}
                  onIonChange={detailHandlerChange}
                  placeholder="+6285X XXXX XXXX"
                  type="tel"
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Alamat</IonLabel>
                <IonTextarea
                  name="alamat"
                  value={dataPesanan?.detail?.alamat}
                  onIonChange={detailHandlerChange}
                  placeholder="Desa Saohiring, Kec. Sinjai Tengah"
                ></IonTextarea>
              </IonItem>

              <IonItemDivider className="ion-padding-top">
                <IonLabel color="dark">Pengiriman</IonLabel>
              </IonItemDivider>
              <IonItem>
                <IonLabel position="stacked">Jenis Pengiriman</IonLabel>
                <IonInput
                  name="jenis"
                  value={dataPesanan?.pengiriman?.jenis}
                  onIonChange={pengirimanHandlerChange}
                  placeholder="COD"
                  type="text"
                ></IonInput>
              </IonItem>

              <IonItem>
                <IonLabel position="stacked">Biaya Pengiriman</IonLabel>
                <IonInput
                  name="biaya"
                  value={dataPesanan?.pengiriman?.biaya}
                  onIonChange={pengirimanHandlerChange}
                  placeholder="Rp 0"
                  type="number"
                ></IonInput>
              </IonItem>
            </IonItemGroup>
          </IonList>

          <IonButton
            disabled={process.disabled}
            color="dark"
            fill="outline"
            className="ion-margin"
            onClick={buat_transaksi}
          >
            {process.text}
          </IonButton>

          <IonButton
            fill="outline"
            disabled={
              dataPesanan?.pembayaran?.dikonfirmasi &&
              dataPesanan?.pembayaran?.dibayar > 0
            }
            className="ion-margin-top ion-margin-bottom"
            color="danger"
            onClick={hapus_transaksi}
          >
            Hapus Transaksi
          </IonButton>

          {/* MODAL Produk */}
          <IonModal
            isOpen={modal.product}
            swipeToClose
            onDidDismiss={() => setModal({ ...modal, product: false })}
          >
            <IonHeader translucent>
              <IonToolbar>
                <IonTitle>Pilih Produk</IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() =>
                      isFilter ? setFilter(false) : setFilter(true)
                    }
                  >
                    <IonIcon
                      color={isFilter ? "secondary" : ""}
                      icon={filter}
                    />
                  </IonButton>
                  <IonButton
                    onClick={() => setModal({ ...modal, product: false })}
                  >
                    Tutup
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>

            <IonContent>
              <IonItemGroup>
                {/* Kategori */}

                {isFilter && (
                  <>
                    <IonCard>
                      <IonItem lines="none">
                        <IonLabel position="stacked">Kategori</IonLabel>
                        <IonSelect
                          interface="action-sheet"
                          value={filterProduct.kategori}
                          placeholder="Pilih kategori"
                          onIonChange={(el) =>
                            setFilterProduct({
                              ...filterProduct,
                              kategori: el.detail.value,
                              nama: "",
                            })
                          }
                        >
                          <IonSelectOption value="">
                            Pilih kategori
                          </IonSelectOption>

                          {mergeArray(
                            filteredProduct.map((el) => el.category)
                          ).map((e) => (
                            <React.Fragment key={e}>
                              <IonSelectOption value={e}>{e}</IonSelectOption>
                            </React.Fragment>
                          ))}
                        </IonSelect>
                      </IonItem>

                      <IonItem lines="none">
                        <IonLabel position="stacked">Merk</IonLabel>
                        <IonSelect
                          interface="action-sheet"
                          value={filterProduct.merk}
                          placeholder="Pilih merk"
                          onIonChange={(e) =>
                            setFilterProduct({
                              ...filterProduct,
                              merk: e.detail.value,
                              nama: "",
                            })
                          }
                        >
                          <IonSelectOption value="">Pilih merk</IonSelectOption>
                          {mergeArray(
                            filteredProduct.map((el) => el.brand)
                          ).map((e) => (
                            <React.Fragment key={e}>
                              <IonSelectOption value={e}>{e}</IonSelectOption>
                            </React.Fragment>
                          ))}
                        </IonSelect>
                      </IonItem>
                    </IonCard>
                  </>
                )}
                <IonItemDivider>Produk</IonItemDivider>
                <IonItem>
                  <IonLabel position="stacked">Nama</IonLabel>
                  <IonSelect
                    interface="action-sheet"
                    value={filterProduct.nama}
                    placeholder="Pilih produk"
                    onIonChange={(e) => {
                      setFilterProduct({
                        ...filterProduct,

                        nama: e.detail.value,
                      });
                      setFilterVarian({
                        ukuran: "",
                        warna: "",
                      });
                    }}
                  >
                    {mergeArray(
                      filteredProduct.map((el) => el.product_name)
                    ).map((e) => (
                      <React.Fragment key={e}>
                        <IonSelectOption value={e}>{e}</IonSelectOption>
                      </React.Fragment>
                    ))}
                  </IonSelect>
                </IonItem>

                {/* Produk */}
                {allVariant.length >= 1 && (
                  <>
                    <IonItemDivider>Varian</IonItemDivider>
                    <IonItem>
                      <IonLabel position="stacked">Warna</IonLabel>
                      <IonSelect
                        value={filterVarian?.warna}
                        onIonChange={(el) =>
                          setFilterVarian({
                            warna: el.detail.value,
                            ukuran: "",
                          })
                        }
                        placeholder={`Pilih  warna`}
                      >
                        {mergeArray(
                          selectedProduct.map((x) => x.data?.warna)
                        ).map((vrn) => (
                          <React.Fragment key={vrn}>
                            <IonSelectOption value={vrn}>{vrn}</IonSelectOption>
                          </React.Fragment>
                        ))}
                      </IonSelect>
                    </IonItem>

                    <IonItem>
                      <IonLabel position="stacked">Ukuran</IonLabel>
                      <IonSelect
                        value={filterVarian?.ukuran}
                        disabled={filterVarian?.warna === ""}
                        onIonChange={(el) =>
                          setFilterVarian({
                            ...filterVarian,
                            ukuran: el.detail.value,
                          })
                        }
                        placeholder={`Pilih  ukuran`}
                      >
                        {mergeArray(
                          selectedProduct
                            .filter((x) => x.data?.warna === filterVarian.warna)
                            .map((x) => x.data?.ukuran)
                        ).map((vrn) => (
                          <React.Fragment key={vrn}>
                            <IonSelectOption value={vrn}>{vrn}</IonSelectOption>
                          </React.Fragment>
                        ))}
                      </IonSelect>
                    </IonItem>

                    <IonItemDivider>Jumlah dan Harga</IonItemDivider>
                    <IonItem>
                    <IonLabel position="stacked" color={updatedStok()[selectedVarian?.sku] <= 0 ? 'danger' : 'dark'}>

                        Jumlah (Stok: {updatedStok()[selectedVarian?.sku] || 0}{" "}
                        )
                      </IonLabel>
                      <IonInput
                       color={updatedStok()[selectedVarian?.sku] <= 0 ? 'danger' : 'dark'}
                        value={tempData.jumlah}
                        onIonChange={(e) => {
                          setTempData({
                            ...tempData,
                            jumlah: Number(e.detail.value),
                          });
                        }}
                        type="number"
                      ></IonInput>
                    </IonItem>

                    <IonItem>
                      <IonLabel position="stacked">Potongan</IonLabel>
                      <IonInput
                        type="number"
                        value={tempData.potongan}
                        onIonChange={(e) =>
                          setTempData({
                            ...tempData,
                            potongan: Number(e.detail.value),
                          })
                        }
                        color="danger"
                      ></IonInput>
                    </IonItem>

                    <IonItem>
                      <IonLabel color="dark">
                        <p>Harga</p>
                        {new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          maximumSignificantDigits: 10,
                        }).format(
                          Number(filteredProduct.filter((e) => e.product_name === filterProduct.nama)[0]?.price || 0) +
                            Number(selectedVarian?.price_changes || 0)
                        )}
                      </IonLabel>
                    </IonItem>

                    {dataPesanan?.pesanan[modal.index]?.isJasa && (
                      <IonItem>
                        <IonLabel color="warning">
                          <p>Harga termasuk biaya sablon</p>
                          {new Intl.NumberFormat("id-ID", {
                            style: "currency",
                            currency: "IDR",
                            maximumSignificantDigits: 10,
                          }).format(
                            (Number(
                              Number(filteredProduct.filter((e) => e.product_name === filterProduct.nama)[0]?.price || 0) +
                                Number(selectedVarian?.price_changes || 0) || 0
                            ) +
                              Number(
                                Object.keys(
                                  dataPesanan?.pesanan[modal.index]?.jasa
                                )
                                  .map((s) =>
                                    hitungSablon(
                                      dataPesanan?.pesanan[modal.index]?.jasa[s]
                                        .panjang,
                                      dataPesanan?.pesanan[modal.index]?.jasa[s]
                                        .lebar
                                    )
                                  )
                                  .reduce((a, b) => a + b, 0)
                              ) || 0) - Number(tempData.potongan)
                          )}
                        </IonLabel>
                      </IonItem>
                    )}

                    <IonItem>
                      <IonLabel color="success">
                        <p>Subtotal</p>

                        {new Intl.NumberFormat("id-ID", {
                          style: "currency",
                          currency: "IDR",
                          maximumSignificantDigits: 10,
                        }).format((
                          (Number(
                            Number(selectedVarian?.harga || 0) +
                              Number(
                                Object.keys(
                                  dataPesanan?.pesanan[modal?.index]?.jasa
                                )
                                  .map((s) =>
                                    hitungSablon(
                                      dataPesanan?.pesanan[modal?.index]?.jasa[s]
                                        ?.panjang,
                                      dataPesanan?.pesanan[modal?.index]?.jasa[s]
                                        ?.lebar
                                    )
                                  )
                                  .reduce((a, b) => a + b, 0)
                              ) || 0
                          ) -
                            tempData?.potongan) *
                            tempData?.jumlah
                        ) || 0)}
                      </IonLabel>
                    </IonItem>
                  </>
                )}
              </IonItemGroup>
            </IonContent>
            <IonFooter>
              <IonToolbar>
                <IonButton
                  disabled={
                    filterVarian.ukuran === "" || filterVarian.warna === ""
                  }
                  className="ion-margin"
                  onClick={() => {
                    let newPesananProduk = [...dataPesanan?.pesanan];
                    newPesananProduk[modal.index] = {
                      ...dataPesanan?.pesanan[modal.index],
                      produk: {
                        ...dataPesanan?.pesanan[modal.index]?.produk,
                        [selectedVarian.sku]: {
                          ...filterProduct,
                          ...selectedVarian,
                          ...tempData,
                          harga:
                            Number(filteredProduct.filter((e) => e.product_name === filterProduct.nama)[0]?.price || 0) +
                            Number(selectedVarian?.price_changes || 0),
                        },
                      },
                    };
                    setDataPesanan({
                      ...dataPesanan,
                      pesanan: newPesananProduk,
                    });
                    setModal({ product: false, index: 0, isEdit: false });
                  }}
                >
                  {modal.isEdit ? "Simpan" : " Tambah"}
                </IonButton>

                {modal.isEdit && (
                  <IonButton
                    color="danger"
                    className="ion-margin"
                    onClick={() => {
                      let newPesananProduk = [...dataPesanan?.pesanan];

                      delete newPesananProduk[modal.index].produk[
                        selectedVarian.sku
                      ];

                      setDataPesanan({
                        ...dataPesanan,
                        pesanan: newPesananProduk,
                      });
                      setModal({ product: false, index: 0 });
                    }}
                  >
                    Hapus
                  </IonButton>
                )}
              </IonToolbar>
            </IonFooter>
          </IonModal>

          <IonModal
            isOpen={modal.service}
            swipeToClose
            onDidDismiss={() =>
              setModal({ ...modal, service: false, isEdit: false })
            }
          >
            <IonHeader translucent>
              <IonToolbar>
                <IonTitle>Tambahkan Paket Sablon</IonTitle>
                <IonButtons slot="end">
                  <IonButton
                    onClick={() =>
                      setModal({ ...modal, service: false, isEdit: false })
                    }
                  >
                    Tutup
                  </IonButton>
                </IonButtons>
              </IonToolbar>
            </IonHeader>

            <IonContent>
              <IonItemGroup>
                <IonItem>
                  <IonLabel position="stacked">Panjang</IonLabel>
                  <IonSelect
                    name="tipe"
                    value={sablon.posisi}
                    onIonChange={(x) =>
                      setSablon({ ...sablon, posisi: x.detail.value })
                    }
                    cancelText="Batal"
                  >
                    <IonSelectOption value="Depan">Depan</IonSelectOption>
                    <IonSelectOption value="Belakang">Belakang</IonSelectOption>
                    <IonSelectOption value="Kiri">Kiri</IonSelectOption>
                    <IonSelectOption value="Kanan">Kanan</IonSelectOption>
                  </IonSelect>
                </IonItem>

                <IonItem>
                  <IonLabel position="stacked">Panjang</IonLabel>
                  <IonInput
                    type="number"
                    value={sablon.panjang}
                    onIonChange={(x) =>
                      setSablon({ ...sablon, panjang: x.detail.value })
                    }
                  ></IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel position="stacked">Lebar</IonLabel>
                  <IonInput
                    type="number"
                    value={sablon.lebar}
                    onIonChange={(x) =>
                      setSablon({ ...sablon, lebar: x.detail.value })
                    }
                  ></IonInput>
                </IonItem>
                <IonItem>
                  <IonLabel color="success">
                    <p>Harga</p>
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      maximumSignificantDigits: 10,
                    }).format(hitungSablon(sablon.panjang, sablon.lebar))}
                  </IonLabel>
                </IonItem>
              </IonItemGroup>
            </IonContent>
            <IonFooter>
              <IonToolbar>
                <IonButton
                  className="ion-margin"
                  onClick={() => {
                    let newPesanan = [...dataPesanan?.pesanan];
                    newPesanan[modal.index] = {
                      ...dataPesanan?.pesanan[modal.index],
                      jasa: {
                        ...dataPesanan?.pesanan[modal.index]?.jasa,
                        [sablon.id]: {
                          ...sablon,
                        },
                      },
                    };
                    setDataPesanan({ ...dataPesanan, pesanan: newPesanan });
                    setModal({ service: false, index: 0, isEdit: false });
                  }}
                >
                  {modal.isEdit ? "Simpan" : " Tambah"}
                </IonButton>

                {modal.isEdit && (
                  <IonButton
                    color="danger"
                    className="ion-margin"
                    onClick={() => {
                      let newPesanan = [...dataPesanan?.pesanan];

                      delete newPesanan[modal.index].jasa[sablon.id];

                      setDataPesanan({ ...dataPesanan, pesanan: newPesanan });
                      setModal({ service: false, index: 0, isEdit: false });
                    }}
                  >
                    Hapus
                  </IonButton>
                )}
              </IonToolbar>
            </IonFooter>
          </IonModal>
        </>
      )}
    </PageLayout>
  );
};

export default EditTransaction;
